import React from 'react';

export default class Aislado extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount(){}

  render(){
    const {show, editar, datos} = this.props;
    return(
      <div style={{display:'flex', flexDirection:'column', width:'100%'}}>
        <div style={{
          display:'flex', flexDirection:'row', width:'calc(100% - 30px)',
          padding:'10px 15px', backgroundColor:'#00b1e9', color:'white',
          fontSize:18, fontFamily:'Barlow_Condensed', fontWeight:'bold'
        }}>
          <strong>8. </strong> &nbsp;
          ¿Está aislado por ser contacto estrecho de un caso confirmado?
        </div>
        <div style={{
          display: show ? 'flex' : 'none',
          flexDirection:'column', width:'100%', margin:'10px 0'
        }}>
          <label style={{display:'block'}}>
            <input
              type="checkbox"
              style={{minWidth:30}}
              checked={datos.aislado}
              onChange={(e) => editar('aislado', e.target.checked)}
            />
            Si
          </label>
          <label style={{display:'block'}}>
            <input
              type="checkbox"
              style={{minWidth:30}}
              checked={!datos.aislado}
              onChange={(e) => editar('aislado', !e.target.checked)}
            />
            No
          </label>
          {datos.intencion &&
            <span style={{margin:3}}>
              Recordar medidas generales de prevención y aislamiento
              <br/>
              <strong>
                Agradecer por su tiempo y comunicarle que en las próximas
                horas será contactado por un operador del centro de llamados
                de la provincia quien le otorgará un turno para recibir la
                primera dosis de la vacuna contra COVID-19 o bien puede usted
                anotar las líneas de comunicación y solicitar de manera
                voluntaria su turno.
              </strong>
            </span>
          }
        </div>
      </div>
    )
  }
}
